import { createAsyncThunk } from '@reduxjs/toolkit'
import { apiCall, getData, getUserApiCall, amendBookApiCall } from '../../../utility/apiHelpers'
import { ApiUrls } from '../../../utility/ApiUrls'
import toast from 'react-hot-toast'
import ToastMessage from '../../../components/toast-messages'

export const getRefreshToken = createAsyncThunk("appCommonReducers/getRefreshToken", async () => {
    const method = 'get'
    const endpoint = `User/GetRefreshToken`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        localStorage.setItem("token", resultData.id_token)
        localStorage.setItem("refresh_token", resultData.refresh_token)
        getUserApiCall()
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    } else {
        return {
            data: null,
            spinner: true,
            tokenExp: false
        }
    }
})

export const displayMenu = createAsyncThunk("appCommonReducers/displayMenu", async (displayMenuBool) => {
    return displayMenuBool
})

export const updateDirtyBool = createAsyncThunk("appCommonReducers/updateDirtyBool", async (dirtyValue) => {
    return dirtyValue
})

export const timeCheck = createAsyncThunk("appCommonReducers/timeCheck", async (dirtyValue) => {
    return dirtyValue || false
})

export const GetQuestions = createAsyncThunk("appCommonReducers/GetQuestions", async (wdata) => {
    const method = 'get'
    const endpoint = `${ApiUrls.GetQuestions}?typeId=${wdata?.type}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

export const GetCasAgreemet = createAsyncThunk("appCommonReducers/GetCasAgreemet", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetCasAgreemet}/?woId=${wdata.file}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

export const GetRcaAgreement = createAsyncThunk("appCommonReducers/GetRcaAgreement", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetRcaAgreement}/?woId=${wdata.file}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

export const GetAffAgreement = createAsyncThunk("appCommonReducers/GetAffAgreement", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetAffAgreement}/?woId=${wdata.file}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

export const GetFamAgreement = createAsyncThunk("appCommonReducers/GetFamAgreement", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetFamAgreement}/?woId=${wdata.file}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

export const GetAgreement = createAsyncThunk("appCommonReducers/GetAgreement", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetAgreement}/?woId=${wdata.file}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

export const GetTCAAgreement = createAsyncThunk("appCommonReducers/GetTCAAgreement", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetTCAAgreement}/?woId=${wdata.file}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

export const GetApplicationData = createAsyncThunk("appCommonReducers/GetApplicationData", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetApplicationData}?${(wdata.tcode === "RC" || wdata.tcode === "RPA" || wdata.tcode === "APR") ? "companyId" : "companyid"}=${wdata.uniqueId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

export const GetCASSupportingDocuments = createAsyncThunk("appCommonReducers/GetCASSupportingDocuments", async (wdata) => {
    const method = 'get'
    const endpoint = `${ApiUrls.GetCASSupportingDocuments}?filepath=${wdata.file}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

export const GetSupportingDocuments = createAsyncThunk("appCommonReducers/GetSupportingDocuments", async (wdata) => {
    const method = 'get'
    const endpoint = `${ApiUrls.GetSupportingDocuments}?filepath=${wdata.file}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})
export const SendFeedbackEmail = createAsyncThunk("appCommonReducers/SendFeedbackEmail", async (wdata) => {
    const method = 'post'
    const endpoint = `${ApiUrls.SendFeedbackEmail}`
    const data = wdata
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        toast(t => (<ToastMessage t={t} message={resultData} status={"sucesss"} />))
        return resultData
    }
})

export const applicationDataBinding = createAsyncThunk("appCommonReducers/applicationDataBinding", async (wdata) => {
    return wdata
})


export const UpdateIsNeedMoreInfo = createAsyncThunk("appCommonReducers/UpdateIsNeedMoreInfo", async (wdata) => {
    const method = 'post'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.RequestMoreInfo}`
    const data = getData(wdata.obj, wdata.ccode, wdata.tcode)
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workorderData = resultData.workorderData
        return {
            data: workorderData,
            data1: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})


// CreateQuestionResponse for CSA Work Order
export const CreateQuestionResponse = createAsyncThunk("appCommonReducers/CreateQuestionResponse", async (wdata) => {
    const method = 'post'
    const endpoint = `${ApiUrls.CreateQuestionResponse}`
    const data = getData(wdata.obj, '', '')
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workorderData = resultData.workorderData
        return {
            data: workorderData,
            data1: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const UpdateQuestionResponse = createAsyncThunk("appCommonReducers/UpdateQuestionResponse", async (wdata) => {
    const method = 'post'
    const endpoint = `${ApiUrls.UpdateQuestionResponse}`
    const data = wdata.obj
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return resultData

    }
})

export const CreateUserCompanyMapping = createAsyncThunk("appCommonReducers/CreateUserCompanyMapping", async (wdata) => {
    const method = 'post'
    const endpoint = `${ApiUrls.CreateUserCompanyMapping}`
    const data = wdata.data
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return resultData
    }
})

export const UpdateUserCompanyMapping = createAsyncThunk("appCommonReducers/UpdateUserCompanyMapping", async (wdata) => {
    const method = 'patch'
    const endpoint = `${ApiUrls.UpdateUserCompanyMapping}`
    const data = wdata?.removingData
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

// Update UpdateNeedMoreInfoStatus Data
export const UpdateNeedMoreInfoStatus = createAsyncThunk("appCommonReducers/UpdateNeedMoreInfoStatus", async (wdata) => {
    const method = 'post'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.UpdateNeedMoreInfoStatus}`
    const data = getData(wdata.obj, wdata.ccode, wdata.tcode)
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workorderData = resultData.workorderData
        return {
            data: workorderData,
            data1: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetComplianceApplicationStatus = createAsyncThunk("appCommonReducers/GetComplianceApplicationStatus", async (wdata) => {
    const method = 'post'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetComplianceApplicationStatus}`
    const data = wdata?.data
    // const data = getData(wdata.woData)
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workorderData = resultData.workorderData
        if (resultData.errorMessage) {
            return {
                errorMessage: resultData.errorMessage,
                spinner: true,
                tokenExp: false
            }
        }
        return {
            data: workorderData,
            data1: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GenerateCRA = createAsyncThunk("appCommonReducers/GenerateCRA", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GenerateCRA}?woId=${wdata.woId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workorderData = resultData.workorderData
        if (resultData.errorMessage) {
            return {
                errorMessage: resultData.errorMessage,
                spinner: true,
                tokenExp: false
            }
        }
        return {
            data: workorderData,
            data1: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

// Update Billing Prefix Workorder
export const RegenerateAuthorizationLetter = createAsyncThunk("appCommonReducers/RegenerateAuthorizationLetter", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${(wdata.tcode === "PEC" || wdata.tcode === "MCG") ? "RegenerateCertificate" : ApiUrls.RegenerateAuthorizationLetter}?woId=${wdata.woId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        toast(t => (<ToastMessage t={t} message={wdata?.status === 5 ? "Document Regenerated Successfully" : "Certificate Regenerated Successfully"} status={"success"} />))
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const RegenerateDocuments = createAsyncThunk("appCommonReducers/RegenerateDocuments", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.RegenerateDocuments}?woId=${wdata.woId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workorderData = resultData.workorderData
        if (resultData.errorMessage) {
            return {
                errorMessage: resultData.errorMessage,
                spinner: true,
                tokenExp: false
            }
        }
        return {
            data: workorderData,
            data1: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetDiscountedProductsCAP = createAsyncThunk("appCommonReducers/GetDiscountedProductsCAP", async (wdata) => {
    const method = 'post'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetDiscountedProductsCAP}`
    const data = wdata.data
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetValidateCAPsGatePassed = createAsyncThunk("appCommonReducers/GetValidateCAPsGatePassed", async (wdata) => {
    const method = 'post'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetValidateCAPsGatePassed}?sapWoId=${wdata.sapWoId}`
    const data = wdata?.woData
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})


export const CreateUserPrinterMapping = createAsyncThunk("appCommonReducers/CreateUserPrinterMapping", async (wdata) => {
    const method = 'post'
    const endpoint = `${ApiUrls.CreateUserPrinterMapping}`
    const data = wdata?.obj
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workorderData = resultData.workorderData
        return {
            data: workorderData,
            data1: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetBookEnquiryData = createAsyncThunk("appCommonReducers/GetBookEnquiryData", async (wdata) => {
    const method = 'post'
    const endpoint = `${ApiUrls.GetBookEnquiryData}`
    const data = wdata?.payload
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetSQCInquiryData = createAsyncThunk("appCommonReducers/GetSQCInquiryData", async (wdata) => {
    const method = 'post'
    const endpoint = `${ApiUrls.GetSQCInquiryData}`
    const data = wdata?.payload
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetLicenseInquiryData = createAsyncThunk("appCommonReducers/GetLicenseInquiryData", async (wdata) => {
    const method = 'post'
    const endpoint = `${ApiUrls.GetLicenseInquiryData}`
    const data = wdata?.payload
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetBookInformation = createAsyncThunk("appCommonReducers/GetBookInformation", async (wdata) => {
    const method = 'get'
    const endpoint = `${ApiUrls.GetBookInformation}?bookId=${wdata.bookId}&crewId=${wdata.crewId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workorderData = resultData
        return {
            data: workorderData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetSqcInformation = createAsyncThunk("appCommonReducers/GetSqcInformation", async (wdata) => {
    const method = 'get'
    const endpoint = `${ApiUrls.GetSqcInformation}?sqcId=${wdata?.SQCId}&crewId=${wdata?.crewId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workorderData = resultData
        return {
            data: workorderData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetLicenseInformationData = createAsyncThunk("appCommonReducers/GetLicenseInformationData", async (wdata) => {
    const method = 'get'
    const endpoint = `${ApiUrls.GetLicenseInformationData}?licenseId=${wdata.LICId}&crewId=${wdata.crewId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workorderData = resultData
        return {
            data: workorderData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const UpdateBook = createAsyncThunk("appCommonReducers/UpdateBook", async (wdata) => {
    const method = 'patch'
    const endpoint = `${ApiUrls.UpdateBook}`
    const data = wdata
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const UpdateSQC = createAsyncThunk("appCommonReducers/UpdateSQC", async (wdata) => {
    const method = 'patch'
    const endpoint = `${ApiUrls.UpdateSQC}`
    const data = wdata
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const UpdateLicense = createAsyncThunk("appCommonReducers/UpdateLicense", async (wdata) => {
    const method = 'patch'
    const endpoint = `${ApiUrls.UpdateLicense}`
    const data = wdata
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})


export const supportingDocumentsList = createAsyncThunk("appCommonReducers/supportingDocumentsList", async (data) => {
    return data
})

export const getClearStatus = createAsyncThunk("appCommonReducers/getClearStatus", async () => {
    return ''
})

export const getClearCloneData = createAsyncThunk("appCommonReducers/getClearCloneData", async () => {
    return ''
})
export const getClearFilephoto = createAsyncThunk("appCommonReducers/getClearFilephoto", async () => {
    return ''
})
export const insreload = createAsyncThunk("appCommonReducers/insreload", async () => {
    return ''
})

export const getClearMultiStatus = createAsyncThunk("appCommonReducers/getClearMultiStatus", async () => {
    return ''
})

export const getClearPaymentStatus = createAsyncThunk("appCommonReducers/getClearPaymentStatus", async () => {
    return ''
})

export const getClearCapWorkorderLsit = createAsyncThunk("appCommonReducers/getClearCapWorkorderLsit", async () => {
    return ''
})

export const CuurentStageVal = createAsyncThunk("appCommonReducers/CuurentStageVal", async (boolean) => {
    return { boolean }
})

export const getWoLoading = createAsyncThunk("appCommonReducers/getWoLoading", async () => {
    return ''
})

export const getClearStore = createAsyncThunk("appCommonReducers/getClearStore", async () => {
    return ''
})

export const getClearNotifications = createAsyncThunk("appCommonReducers/getClearNotifications", async () => {
    return ''
})

export const getClearExistingData = createAsyncThunk("appCommonReducers/getClearExistingData", async () => {
    return ''
})

export const getClearStoreData = createAsyncThunk("appCommonReducers/getClearStoreData", async () => {
    return ''
})

export const getClearFileData = createAsyncThunk("appCommonReducers/getClearFileData", async () => {
    return ''
})

export const removeneedinfodata = createAsyncThunk("appCommonReducers/removeneedinfodata", async () => {
    return ''
})

export const getFileExceed = createAsyncThunk("appCommonReducers/getFileExceed", async () => {
    return ''
})

export const setShowHideMenuData = createAsyncThunk("appCommonReducers/setShowHideMenuData", async (name) => {
    return name
})

export const getStepNameStatus = createAsyncThunk("appCommonReducers/getStepNameStatus", async (name) => {
    return name
})

export const GetAppVersions = createAsyncThunk("appCommonReducers/GetAppVersions", async (obj) => {
    const method = 'get'
    const endpoint = `${ApiUrls.GetAppVersions}?appTypeId=${obj.appType}`
    const payload = ''
    const wdata = obj
    const resultData = await apiCall(method, endpoint, payload)
    if (resultData) {
        const allVesrsions = []
        resultData.forEach((element, index) => {
            const obj = { ...element }
            obj['id'] = index + 1
            allVesrsions.push(obj)
        })
        return {
            data: allVesrsions,
            perPage: wdata.perPage,
            page: wdata.page,
            totCount: resultData?.count,
            spinner: true,
            tokenExp: false
        }
    } else {
        return {
            data: [],
            spinner: true,
            tokenExp: false
        }
    }
})

export const DisableEnabled = createAsyncThunk("appCommonReducers/DisableEnabled", async (wdata) => {
    const method = 'post'
    const endpoint = `${ApiUrls.AppVersionDisableEnabled}`
    const data = wdata.data
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    } else {
        return {
            data: null,
            spinner: true,
            tokenExp: false
        }
    }
})

export const CreateAppVersion = createAsyncThunk("appCommonReducers/CreateAppVersion", async (wdata) => {
    const method = 'post'
    const endpoint = `${ApiUrls.CreateAppVersion}`
    const data = getData(wdata?.data, '', '')
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    } else {
        return {
            data: null,
            spinner: true,
            tokenExp: false
        }
    }
})

export const AmendBook = createAsyncThunk("appCommonReducers/AmendBook", async (wdata, thunkAPI) => {
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.AmendBook}`
    const stateWoIData = thunkAPI?.getState?.()?.commonreducerSlice?.woIData
    const data = {
        ...(wdata?.data || {}),
        woDataModifiedDate: wdata?.data?.woDataModifiedDate || stateWoIData?.woDataModifiedDate || null
    }
    const resultData = await amendBookApiCall(endpoint, data)
    if (resultData) {
        const workorderData = resultData?.data?.workorderData
        if (resultData) {
            return {
                errorMessage: resultData?.errorMessage,
                data: workorderData,
                data1: resultData?.data,
                spinner: true,
                tokenExp: false
            }
        }
    }
})

export const CreateBook = createAsyncThunk("appCommonReducers/CreateBook", async (wdata) => {
    const method = 'post'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.CreateBook}`
    const data = wdata?.data
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workorderData = resultData.workorderData
        if (resultData.errorMessage) {
            return {
                errorMessage: resultData.errorMessage,
                spinner: true,
                tokenExp: false
            }
        }
        return {
            data: workorderData,
            data1: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GenerateDocuments = createAsyncThunk("appCommonReducers/GenerateDocuments", async (wdata) => {
    const method = 'post'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GenerateDocuments}`
    const data = wdata?.obj
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workorderData = resultData.workorderData
        if (resultData.errorMessage) {
            return {
                errorMessage: resultData.errorMessage,
                spinner: true,
                tokenExp: false
            }
        }
        return {
            data: workorderData,
            data1: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const saveCSVRCWDocument = createAsyncThunk("appCommonReducers/saveCSVRCWDocument", async (wdata) => {
    const values = wdata.fileData
    if (values.fileDto.length > 0) {
        const formData = new FormData()
        formData.append("file", values.fileDto[0].file)
        const woType = values.fileDto[0].type
        const method = 'post'
        const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.ValidateCodesDetails}?woId=${values.woId}&agentId=${wdata.agntId}`
        const data = formData
        const resultData = await apiCall(method, endpoint, data)
        if (resultData) {
            return {
                data: resultData,
                spinner: true,
                tokenExp: false,
                woType,
                woTypeId: values.woId,
                stype: values.stype,
                errorMsg: ''
            }
        }
    }
})

export const GetDocumentHistory = createAsyncThunk("appCommonReducers/GetDocumentHistory", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetDocumentHistory}?crewId=${wdata?.id}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetCCGPreviewAgreement = createAsyncThunk("appCommonReducers/GetCCGPreviewAgreement", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetCCGPreviewAgreement}?woId=${wdata.woId}&userEmail=${wdata.email}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

export const GetCCGCOPYAgreement = createAsyncThunk("appCommonReducers/GetCCGCOPYAgreement", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetCCGCOPYAgreement}/?woId=${wdata.file}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

export const SendAlertEmail = createAsyncThunk("appCommonReducers/SendAlertEmail", async (wdata) => {
    const method = 'post'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.SendAlertEmail}`
    const data = wdata.obj
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return { data: resultData, spinner: true, tokenExp: false }
    } else {
        return { data: [], spinner: true, tokenExp: false }
    }
})

export const ResendPendingDocumentsToVault = createAsyncThunk("appCommonReducers/ResendPendingDocumentsToVault", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.ResendPendingDocumentsToVault}?${wdata.tcode === "SAP" ? `woId=${wdata.parentWoId}` : `submitWorkOrderId=${wdata.parentWoId}`}`
    const data = ""
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return { data: resultData, spinner: true, tokenExp: false }
    } else {
        return { data: [], spinner: true, tokenExp: false }
    }
})

export const GetUserPrinterMappings = createAsyncThunk("appCommonReducers/GetUserPrinterMappings", async (wdata) => {
    const method = 'get'
    const endpoint = `${ApiUrls.GetUserPrinterMappings}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workorderData = resultData
        return {
            data: workorderData,
            spinner: true,
            tokenExp: false
        }
    }
})


export const AppVersionDisableEnabled = createAsyncThunk("appCommonReducers/AppVersionDisableEnabled", async (wdata) => {
    const method = 'post'
    const endpoint = `${ApiUrls.AppVersionDisableEnabled}`
    const data = wdata.data
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    } else {
        return {
            data: null,
            spinner: true,
            tokenExp: false
        }
    }
})
